import observer from 'saddlebag-observer';

import type { MBDEvent } from '../types';

const sendEvent = (event: MBDEvent, messageGuid?: string) => {
  const fullSchemaName =
    'element_impression_guid' in event
      ? 'user_behaviour_data_domain.ElementInteraction'
      : 'user_behaviour_data_domain.ElementImpression';

  const observerEvent = {
    isMiniEvent: true,
    consentRequired: true,
    eventName: 'mbd-web',
    fullSchemaName,
    message: event,
  };

  observer.publish(
    'grappler-track',
    messageGuid
      ? {
          ...observerEvent,
          ...{
            messageOpts: {
              messageGuid,
            },
          },
        }
      : observerEvent,
  );
};

export default sendEvent;
